var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockNavyYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z",
    fill: "#AA8208"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.25C6.41421 2.25 6.75 2.58579 6.75 3V5.68934L8.03033 6.96967C8.32322 7.26256 8.32322 7.73744 8.03033 8.03033C7.73744 8.32322 7.26256 8.32322 6.96967 8.03033L5.46967 6.53033C5.32902 6.38968 5.25 6.19891 5.25 6V3C5.25 2.58579 5.58579 2.25 6 2.25Z",
    fill: "#AA8208"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockNavyYellow);
export default __webpack_public_path__ + "static/media/clockNavyYellow.9cbff86e48ebcf60e92a0e9d4edd8a2f.svg";
export { ForwardRef as ReactComponent };